import { ContentAccessibilityPopup } from './contentAccessibilityPopup.model';
import { ContentAdvisories } from './contentadvisories.model';
import { ContentAirportLookup } from './contentAirportLookup.model';
import { ContentAlertAdvisories } from './contentalertadvisories.model';
import { ContentCookieDetails } from './contentCookieDetails.model';
import { ContentDarkSite } from './contentDarkSite.model';
import { ContentFlightHotel } from './contentFlightHotel.model';
import { ContentFooter } from './contentfooter.model';
import { ContentHeader } from './contentheader.model';
import { ContentLogo } from './contentLogo.model';
import { ContentNextGenHeader } from './contentNextGenHeader.model';
import { ContentnonJVFlying } from './contentnonJVFlying.model';
import { ContentSessionTimeOut } from './contentsessiontimeout.model';
import { UnSupportedBrowser } from './contentUnsupportedBrowser.model';

export class ContentHeaderFooter {
  header: ContentHeader;
  footer: ContentFooter;
  cookiePolicy: ContentCookieDetails;
  darkSite: ContentDarkSite;
  advisories: ContentAdvisories;
  applicationadvisories: ContentAlertAdvisories;
  accessibilityPopup: ContentAccessibilityPopup;
  airportLookup: ContentAirportLookup;
  unsupportedBrowserPopup: UnSupportedBrowser;
  sessionTimeoutMessage: ContentSessionTimeOut;
  logo: ContentLogo;
  flightPlusHotel: ContentFlightHotel;
  axBrandName: string;
  nonJVFlying: ContentnonJVFlying;
  nextgenReshopHeader: ContentNextGenHeader;

  constructor(contentjson?: any) {
    if (contentjson !== undefined && contentjson !== null) {
      if (contentjson['header']) {
        this.header = new ContentHeader(contentjson['header']);
      } else {
        this.header = new ContentHeader();
      }
      if (contentjson['footer']) {
        this.footer = new ContentFooter(contentjson['footer']);
      } else {
        this.footer = new ContentFooter();
      }
      if (contentjson['cookiePolicy']) {
        this.cookiePolicy = new ContentCookieDetails(
          contentjson['cookiePolicy']
        );
      } else {
        this.cookiePolicy = new ContentCookieDetails();
      }
      if (contentjson['darkSite']) {
        this.darkSite = new ContentDarkSite(contentjson['darkSite']);
      } else {
        this.darkSite = new ContentDarkSite();
      }
      if (contentjson['advisories']) {
        this.advisories = new ContentAdvisories(contentjson['advisories']);
      } else {
        this.advisories = new ContentAdvisories();
      }
      if (contentjson['applicationadvisories']) {
        this.applicationadvisories = new ContentAlertAdvisories(
          contentjson['applicationadvisories']
        );
      } else {
        this.applicationadvisories = new ContentAlertAdvisories();
      }
      if (contentjson['accessibilityPopUp']) {
        this.accessibilityPopup = new ContentAccessibilityPopup(
          contentjson['accessibilityPopUp']
        );
      } else {
        this.accessibilityPopup = new ContentAccessibilityPopup();
      }
      if (contentjson['logo']) {
        this.logo = new ContentLogo(contentjson['logo']);
      } else {
        this.logo = new ContentLogo();
      }
      if (contentjson['airportLookup']) {
        this.airportLookup = new ContentAirportLookup(
          contentjson['airportLookup']
        );
      } else {
        this.airportLookup = new ContentAirportLookup();
      }
      if (contentjson['unsupportedBrowserPopup']) {
        this.unsupportedBrowserPopup = new UnSupportedBrowser(
          contentjson['unsupportedBrowserPopup']
        );
      } else {
        this.unsupportedBrowserPopup = new UnSupportedBrowser();
      }
      if (contentjson['sessionTimeoutMessage']) {
        this.sessionTimeoutMessage = new ContentSessionTimeOut(
          contentjson['sessionTimeoutMessage']
        );
      } else {
        this.sessionTimeoutMessage = new ContentSessionTimeOut();
      }
      if (contentjson['flightPlusHotel']) {
        this.flightPlusHotel = new ContentFlightHotel(
          contentjson['flightPlusHotel']
        );
      } else {
        this.flightPlusHotel = new ContentFlightHotel();
      }
      if (contentjson['axBrandName']) {
        this.axBrandName = contentjson['axBrandName'];
      } else {
        this.axBrandName = '';
      }
      if (contentjson['nonJVFlying']) {
        this.nonJVFlying = new ContentnonJVFlying(contentjson['nonJVFlying']);
      } else {
        this.nonJVFlying = new ContentnonJVFlying();
      }
      if (contentjson['nextgenReshopHeader']) {
        this.nextgenReshopHeader = new ContentNextGenHeader(
          contentjson['nextgenReshopHeader']
        );
      } else {
        this.nextgenReshopHeader = new ContentNextGenHeader();
      }
    } else {
      this.header = new ContentHeader();
      this.footer = new ContentFooter();
    }
  }
}
